import classNames from 'classnames';
import { IconNameV1, IconV1 } from 'common/icon/iconV1.js';
import { ICON_MODIFIERS } from 'components/weather-warning/header-warning-types.js';
import { useContext } from 'react';
import { WarningSeverityContext } from 'utilities/weather-warnings/context/context-warning-severity.js';
import { WarningSeverity, getSeverityInfo } from 'utilities/weather-warnings/warning-severity.js';

export const MobileHeaderWarning = ({ isTabOpen }: { isTabOpen?: boolean }) => {
  const { warningSeverity } = useContext(WarningSeverityContext);
  return <MobileHeaderWarningCore isTabOpen={isTabOpen} warningSeverity={warningSeverity} />;
};

export const MobileHeaderWarningCore = ({
  isTabOpen,
  warningSeverity,
}: {
  isTabOpen?: boolean;
  warningSeverity: WarningSeverity;
}) => {
  const icon = ICON_MODIFIERS[warningSeverity] as IconNameV1;

  if (!icon || warningSeverity === WarningSeverity.None) {
    return null;
  }

  const { colorClass } = getSeverityInfo(warningSeverity);

  return (
    <div className={classNames('SmallHeaderWarning', colorClass, { 'is-open': isTabOpen })}>
      <IconV1 iconClass="SmallHeaderWarning-icon SVG--sm" icon={icon} />
    </div>
  );
};
